import styled from "styled-components";
import fonts from "styles/fonts";

export const StyledErrorMessage = styled.p`
  font-family: "Source Sans Pro", sans-serif;
  font-size: ${fonts.small};
`;
